import * as utils from '@app/shared/utils/utils';
import * as util from "util";

export enum messageTypes { TEXT, IMG, AUDIO, DOC, VIDEO }

export interface IChatMessage {
  fromID: string;
  message: string;
  messageID: string;
  sentAt: number;
  deleted?: boolean;
  media?: IChatMedia;
  type: messageTypes;
  deliveredAt?: Map<string, string>;
  readAt?: Map<string, string>;
}

export interface IChatMedia {
  extension?: string;
  height?: number;
  latitude?: number;
  longitude?: number;
  messageId?: string;
  photoID?: string;
  size?: number;
  thumb?: string;
  url: string;
  width?: number;
  audioID?: string;
  currentProgress?: number;
  duration?: number;
  documentID?: string;
  documentName?: string;
  mimetype?: string;
  previewUrl?: string;
}

export interface IUserChat {
  firebaseID: string;
  firstName: string;
  joinedAt: number;
  lastName: string;
  online: boolean;
  phone: string;
  photo: string;
  tagLine: string;
  userId: string;
}

export class PhotoMedia implements Partial<IChatMedia> {
  extension: string;
  photoID?: string;
  size?: number;
  url: string;
  messageId = '-1';
  latitude = -1;
  longitude = -1;
  height = 0;
  width = 0;
  thumb = '';

  constructor(media: any) {
    this.extension = utils.getFileExtension(media.name);
    this.size = media.size;
    this.photoID = media.id;
  }
}

export class DocMedia implements Partial<IChatMedia> {
  documentID: string;
  documentName: string;
  extension: string;
  messageId?: string;
  mimetype: string;
  previewUrl?: string;
  size: number;
  url: string;

  constructor(media: any) {
    this.documentName = utils.getFileName(media.name);
    this.extension = utils.getFileExtension(media.name);
    this.mimetype = media.type;
    this.size = media.size;
    this.documentID = media.id;
  }
}

export class AudioMedia implements Partial<IChatMedia> {
  audioID: string;
  extension: string;
  currentProgress?: number;
  duration: number;
  messageId: string;
  url: string;

  constructor(media: any) {
    this.audioID = media.id || utils.getFileName(media.name);
    this.extension = media.extension || utils.getFileExtension(media.name);
    this.duration = media.duration;
  }
}

export class ChatMessage implements IChatMessage {
  fromID: string;
  message: string;
  messageID: string;
  sentAt: number;
  deleted?: boolean;
  media?: IChatMedia;
  card?: any;
  type: messageTypes;
  deliveredAt?: Map<string, string>;
  readAt?: Map<string, string>;

  constructor(sender: string, message: string, time: any, media?: any) {
    this.message = message;
    this.sentAt = time;
    this.deleted = false;
    this.fromID = sender;
    this.messageID = '-1';
    this.type = messageTypes.TEXT;

    if (media) {
      if (media.type.includes('image')) {
        this.type = messageTypes.IMG;
        this.media = new PhotoMedia(media);
      } else if (media.type.includes('audio')) {
        this.type = messageTypes.AUDIO;
        this.media = new AudioMedia(media);
      } else if (media.type.includes('video')) {
        this.type = messageTypes.DOC; // messageTypes.VIDEO
        this.media = new DocMedia(media);
      } else if (media) {
        this.type = messageTypes.DOC;
        this.media = new DocMedia(media);
      }
    }

  }
}

export class GenericMedia  {
  id: string;
  name: string;
  size: string;
  type: string;
  duration: number;

  constructor(metadata) {
    this.id = metadata.id;
    this.name = metadata.name;
    this.size = metadata.size;
    this.type = metadata.contentType;
    this.duration = metadata.duration;
  }
}


